import ReactGA from 'react-ga4'

export const reactGAEvent = (category, action) => {
    ReactGA.event({
        category,
        action,
    })
}
